import React from "react";
import { ResponsivePictureViewModel } from "../../ReactComponents/responsivePicture/ResponsivePictureViewModel.csharp";
import { ResponsivePicture } from "../../ReactComponents/responsivePicture/responsivePicture";
import { PictureProfile } from "../../../ResizedImage/PictureProfile.csharp";
import { ExhibitionCardViewModel } from "../ExhibitionCard/ExhibitionCardViewModel.csharp";
import { ExhibitionItemViewModel } from "../../Blocks/ExhibitionsListBlock/ExhibitionItemViewModel.csharp";
import { CardTranslations } from "../Card/CardTranslations.csharp";
import { ExhibitionType } from "../../Pages/Exhibitions/ExhibitionPage/ExhibitionType.csharp";

const getExhibitionTypeTranslation = (exhibitionType: ExhibitionType, translations: CardTranslations): string => {
    switch (exhibitionType) {
        case ExhibitionType.Exhibition:
            return translations.permanentExhibitionCollection;
        case ExhibitionType.InteractiveExperience:
            return translations.interactiveExperience;
        default:
            return translations.permanentExhibition;
    }
};

export const NewExhibitionCard: React.FC<ExhibitionItemViewModel> = (props) => {
    const {
        title,
        subtitle,
        image,
        shortDescription,
        floor,
        exhibitionType,
        isComingSoon,
        comingDateText,
        pageUrl,
        theme,
        customThemeBackgroundColor,
        customThemeFontColor,
        defaultProfile,
        isTemporary,
        cardTranslations,
        duration,
    } = props;

    const cardStyle: React.CSSProperties = {
        cursor: pageUrl ? "pointer" : "default",
    };
    let cardClass = "NewExhibitionCard";

    if (theme === "custom" && customThemeBackgroundColor && customThemeFontColor) {
        cardStyle.background = customThemeBackgroundColor;
        cardStyle.color = customThemeFontColor;
        cardClass += " NewExhibitionCard--custom";
    } else {
        cardClass += ` NewExhibitionCard--${theme}`;
    }

    return (
        <a className={cardClass} style={cardStyle} href={pageUrl}>
            {image && (
                <div className="NewExhibitionCard__Image">
                    <ResponsivePicture model={image} profile={defaultProfile} />
                </div>
            )}
            <div className="NewExhibitionCard__Content">
                <h3 className="NewExhibitionCard__Title">{title.toUpperCase()}</h3>
                {subtitle && <div className="NewExhibitionCard__Subtitle">{subtitle.toUpperCase()}</div>}
                {shortDescription && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: shortDescription,
                        }}
                        className="NewExhibitionCard__Description"
                    ></div>
                )}

                <div className="NewExhibitionCard__Footer">
                    {isComingSoon && comingDateText ? (
                        <span className="NewExhibitionCard__Type">{comingDateText}</span>
                    ) : (
                        <span className="NewExhibitionCard__Type">
                            {exhibitionType === ExhibitionType.NoMarking && !duration
                                ? null
                                : duration ||
                                  (cardTranslations
                                      ? getExhibitionTypeTranslation(exhibitionType, cardTranslations)
                                      : ExhibitionType[exhibitionType])}
                        </span>
                    )}
                    {floor && <span className="NewExhibitionCard__Location">{floor}</span>}
                </div>
            </div>
        </a>
    );
};
